import { PLACES_KEY } from '@/services/Configuration'

import {
  placesAPIPresent,
} from '.'

export const addGooglePlacesAPI = () => (
  // Add and then check if places API is present.
  new Promise((resolve, reject) => {
    if (placesAPIPresent()) {
      resolve(true)
    } else {
      const placesScript = document.createElement('script')
      placesScript.setAttribute('type', 'text/javascript')
      placesScript.setAttribute('src', `https://maps.googleapis.com/maps/api/js?key=${PLACES_KEY}&libraries=places`)
      const scriptOnLoad = () => {
        if (placesAPIPresent()) {
          placesScript.removeEventListener('load', scriptOnLoad)
          resolve(true)
        } else {
          reject(new Error('Failed to verify places API'))
        }
      }
      placesScript.addEventListener('load', scriptOnLoad)
      document.head.appendChild(placesScript)
      setTimeout(() => reject(new Error('TIMEOUT more than 3.5s trying to load the script  This should load in less than 300ms')), 350)
    }
  })
)
